  <template>
  <el-table-column
    :prop="props.prop"
    :label="props.label"
    :width="props.width"
    :size="18"
  >
    <template #header>
      <div class="filter-cell">
        <div>
          <div class="filter-cell-title">{{ props.label }}</div>
        </div>
        <div class="filter-cell-icon">
          <el-popover
            placement="bottom-end"
            title=""
            width="250"
            :visible="activeFilterLabel === props.label"
          >
            <div class="filter-cell-control">
              <el-input v-model="searchKey" :clearable="true"></el-input>
              <div style="padding-top: 5px">
                <el-button type="primary" size="small" @click="search"
                  >confirm</el-button
                >
                <el-button
                  type="primary"
                  size="small"
                  @click="activeFilterLabel = ''"
                  >close</el-button
                >
              </div>
            </div>
            <template #reference>
              <el-button type="text" style="margin-top:10px" @click="activeFilterLabel = props.label">
                <el-icon :size="18" style="color: var(--el-text-color-primary)">
                  <Search />
                </el-icon>
              </el-button>
            </template>
          </el-popover>
        </div>
      </div>
    </template>
    <template #default="data">
      <el-link style="font-size: 11px" @click="linkClick(data.row)" type="primary">{{
        data.row["" + props.prop + ""]
      }}</el-link>
    </template>
  </el-table-column>
</template>
<script setup>
import { ref } from "vue";
import PubSub from "pubsub-js";
import { Search } from "@element-plus/icons-vue";

const activeFilterLabel = ref("");
const searchKey = ref("");
const props = defineProps({
  prop: {
    type: String,
    default: "prop",
  },
  label: {
    type: String,
    default: "label",
  },
  width: {
    type: Number,
    default: 100,
  },
});
const emit = defineEmits(["search"]);
const search = () => {
  activeFilterLabel.value = "";
  var data = {
    key: props.prop,
    value: searchKey.value,
  };
  PubSub.publish("mode", data);
  emit("search");
};
//点击
const linkClick = (data) => {
  PubSub.publish("modeclick", data);
};
</script>
<style>
.filter-cell {
  height: 32px;
}

.filter-cell-title {
  padding: 5px 0;
}

.filter-cell-icon {
  position: absolute;
  top: 0;
  right: 12px;
}
.filter-cell-control {
  min-width: 230px;
}
</style>


